export default "__VITE_ASSET__gayYZCPU__"